module.exports = __webpack_public_path__ + "static/media/employee-appreciation-4.1b70f883.jpg";